<template>
  <div class="zyf" ref="box">
    <v-header :inputName='Name'></v-header>
    <v-serch @search="searchName"></v-serch>
    <v-crumbs v-if="showcrumbs" :showother="true" ref="crumbs" style="width: 1280px;" @search="searchAll"></v-crumbs>
    <collegeList :list="data" :guding="guding" :userCang="userCang" @shou="shou"></collegeList>
    <!-- <div class="container tablecon" style="width: 1280px;">
      <div class="two" id="yuanshu1" :class="{'gudingo':guding}" v-for="(item,index9) in Title" :key="index9+9">
        <div class="T_title1">{{item.til1}}</div>
        <div class="T_title2">{{item.til2}}</div>
        <div class="T_title3">{{item.til3}}</div>
        <div class="T_title4">{{item.til4}}</div>
        <div class="T_title5">{{item.til5}}</div>
        <div class="T_title6">{{item.til6}}</div>
        <div class="T_title7">{{item.til7}}</div>
        <div class="T_title8">{{item.til8}}</div>
      </div>
      <div class="three" id="yuanshu2">
        <div class="three_for" v-for="(college,index) in data">
          <div class="Cont Cont1">
            <div class="Cont_img">
              <img style="width: 100%;height: 100%;" :src="($resourcesUrl+'/college/'+`${college.collegeId}`+'/'+`${college.collegeIcon}`)" width="110px"
                height="110px">
            </div>
            <div class="Cont_Nr">
              <p  @click="xueshengjianjie(0,college)">{{college.collegeName}}</p>
              <div class="Cont_Card" v-if="college.collegeLevel!=null&&college.collegeLevel!=''">
                <span v-for="(list,index12) in college.collegeLevel.split(',')">{{list}}</span>
              </div>
              <div class="Cont_Card" v-if="college.college!=null">
                <icollege :item="college"></icollege>
              </div>
            </div>
          </div>
          <div class="Cont Cont2">
            <p>{{college.collegeRank}}</p>
          </div>
          <div class="Cont Cont3">
            <p>{{AREA_OBJ[college.collegeArea]}}</p>
          </div>
          <div class="Cont Cont4">
            <p>{{college.collegeSubject}}</p>
          </div>
          <div class="Cont Cont5">
            <p>{{college.collegeNature == 1?'公立':'民办'}}</p>

          </div>
          <div class="Cont Cont6">
            <p>{{college.collegeSubjection}}</p>
          </div>
          <div class="Cont Cont7">
            <p>{{college.collegeEducational}}</p>
          </div>
          <div class="Cont Cont8">
            <div class="Cont8_Le">
              <div class="Cont8_Le1" @click="xueshengjianjie(4,college)">院校分数线</div>
              <div class="Cont8_Le2" @click="toluqulv(college)">测试录取率</div>
            </div>
            <div class="Cont8_Ri">
              <p @click="xueshengjianjie(0,college)">院校简介</p>
              <p @click="xueshengjianjie(3,college)">招生简章</p>
              <p @click="xueshengjianjie(4,college)">录取数据</p>
            </div>
            <div class="Cont8_dw" @click="shou(college.collegeId)">
              <img src="../../../src/assets/img/tuceng9.png" v-if="userCang.indexOf(college.collegeId)!=-1">
              <img src="../../../src/assets/img/tuceng8.png" v-else>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <item7></item7>
    <zuoxuanfu1></zuoxuanfu1>
  </div>
</template>

<script>
  import vSerch from '../../components/vSerch.vue'
  import vCrumbs from '../../components/vCrumbs.vue'
  import vHeader from '../../components/vHeader.vue'
  import zuoxuanfu1 from '../../components/zuoxuanfu1.vue'

  import item7 from '../../components/item7.vue'
  import collegeList from './collegelist.vue'
  export default {
    data() {
      return {
        // 头固定
        guding: false,
        showcrumbs:true,
        Name: 2,
        isTrue: 0,
        isTrue1: 0,
        isTrue2: 0,
        isTrue3: 0,
        // 面包屑渲染

        // 标题
        Title: [{
          til1: '院校名称',
          til2: '排名',
          til3: '地区',
          til4: '类型',
          til5: '性质',
          til6: '隶属',
          til7: '学历层次',
          til8: '操作',
        }],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        loadMoreText: "加载中...",
        showLoadMore: false,
        queryObj: {},
        data: [],

        userCang: [],
        loadding:false

      };
    },
    components: {
      item7,
      vHeader,
      zuoxuanfu1,
      vSerch,
      vCrumbs,
      collegeList
    },
    mounted() {
      window.addEventListener('scroll', this.handleScrollx, true)
    },
    methods: {
      searchName(name){
        console.log(111)
        this.queryObj.collegeName = name
        this.showcrumbs = false
        this.$nextTick(()=>(this.showcrumbs = true))
        this.queryObj.collegeAreas = ''
        this.queryObj.collegeLevel = ''
        this.queryObj.collegeSubject = ''
        this.queryObj.collegeSubjection = ''
         this.pageNum = 1;
         this.total = 0;
         this.data = []
         this.getData();
      },
      searchAll(obj){
        this.queryObj.collegeAreas = obj.collegeAreas
        this.queryObj.collegeLevel = obj.collegeLevel
        this.queryObj.collegeSubject = obj.collegeSubject
        this.queryObj.collegeSubjection = obj.collegeSubjection
        this.pageNum = 1;
        this.total = 0;
        this.data = []
        this.getData();
      },
      handleScrollx(e) {
        if(this.$route.path == '/zyf'){
          let tedItem = document.querySelector("#yuanshu1")
          let tedItem2 = document.querySelector("#yuanshu2")
          var scrollTop1 = tedItem.getBoundingClientRect().top
          var scrollTop2 = tedItem2.getBoundingClientRect().top
          if (scrollTop1 <= 100) {
            this.guding = true
          }
          if (scrollTop2 >= 200) {
            this.guding = false
          }
          const scrollY =
            document.body.scrollTop || document.documentElement.scrollTop; // 滚动条在Y轴上的滚动距离
          const compatibility =
            document.compatMode === "CSS1Compat" ?
            document.documentElement.clientHeight :
            document.body.clientHeight;
          // clientHeight 属性是一个只读属性，它返回该元素的像素高度，高度包含内边距（padding），不包含边框（border），外边距（margin）和滚动条，是一个整数，单位是像素 px。
          // 页面总高度
          const TotalHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
          );
          // 当滚动条滑到页面底部
          if (compatibility + scrollY >= (TotalHeight-400)) {

            if(this.pageNum<this.total&&!this.loadding){
              this.pageNum++;
              this.getData()

            }
          }
        }

      },

      isT(index) {
        this.isTrue = index;
      },
      isT1(index) {
        this.isTrue1 = index;
      },
      isT2(index) {
        this.isTrue2 = index;
      },
      isT3(index) {
        this.isTrue3 = index;
      },

      shou(id) {
      	let _this = this;
      	let flag1 = this.$utils.getLoginStatus();
      	if (flag1) {
      		let obj = this.$utils.getlocalStorage('userCang')
      		let list = obj.college
      		if (list.indexOf(id) == -1) {
      			_this.$req.insert("collectionTable", {
      				dataType: 1,
      				dataId: id,
              userId:this.$utils.getlocalStorage('userInfo').userId
      			}).then(function(resp) {
      				if (resp.status == 0) {
      					list.push(id);
      					_this.userCang = list
      					obj.college = list
      					_this.$utils.setlocalStorage("userCang", obj);
      				}
      			})

      		} else {
      			_this.$req.batchDelete("collectionTable", {
      				data_type: 1,
      				data_id: id
      			}).then(function(resp) {
      				if (resp.status == 0) {
      					list.splice(list.indexOf(id), 1);
      					_this.userCang = list
      					obj.college = list
      					_this.$utils.setlocalStorage("userCang", obj);
      				}
      			})
      		}
      	}
      },


      getData() {
        let _this = this;
        if (this.pageNum == 1) {
         document.body.scrollTop = 0
        }
        this.loadding = true;
        this.$req.queryAllByLimit("collegeTable", {
          pageSize: _this.pageSize,
          pageNum: _this.pageNum,
          queryObj: _this.queryObj
        }).then(function(response) {
          _this.loadding = false;
          _this.data = _this.data.concat(response.data)
          _this.total = response.pages;
          _this.showLoadMore = false;
        })

      },
    },
    created() {
      let userCang = this.$utils.getlocalStorage('userCang')
      if(userCang!=null&&userCang!=''){
        this.userCang = userCang.college
      }
      this.getData()
    }
  };
</script>

<style scoped="scoped">


  /* 设置个别宽度不是以下不是此范围的样式 */
  @media (min-width:1400px) {
    .container {
      width: 1530px;
    }
  }


  @media (max-width:750px) {
    .gudingo {
      width: 100% !important;
      overflow-y: hidden;
      overflow-x: auto;
    }

    .gudingo .T_title8 {
      width: 300px !important;
      flex-shrink: 0;
      flex: none;
    }

    .two {
      width: 1500px;
    }

    .tablecon {
      overflow: auto;
    }

    .three {
      width: 1500px;
    }
  }


  @media (max-width:980px) {
    .two {
      width: 1500px;
    }

    .tablecon {
      overflow: auto;
    }

    .three {
      width: 1500px;
    }
  }


  @media (max-width:1400px) {
    .two {
      width: 1500px;
    }

    .tablecon {
      overflow: auto;
    }

    .three {
      width: 1280px;
    }

    .maskA {
      width: 80%;
      height: 80%;
    }

    .maskAA {
      width: 100%;
    }

    .two_A {
      width: 850px;
      height: 46px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/information/college.vue